export default __webpack_public_path__ + "static/media/error-image.9d0fd66f.png";